import { checkIfPushNotificationsWork } from "@/helpers/checkIfPushNotificationsWork";
import { v4 as uuidv4 } from 'uuid';
import RESTAPIConfig from "@/config/RESTAPIConfig";
import configuredStore from "@/store/Store";
import { getAccessToken, userLangHeaderName } from "@/store/ApiSlice";
import axios from "axios";
import { NewBaseResponseInterface } from "@/common/Http/Interfaces/NewBaseResponseInterface";
import { publicVapidKey, storageKey } from "./Config/RootServiceWorkerConfig";

export async function runRootServiceWorker() {
    if (localStorage.getItem(storageKey) === "yes") {
        return;
    }

    if ('serviceWorker' in navigator) {

        const pushesAvailable = await checkIfPushNotificationsWork();
        if (!pushesAvailable) {
            return;
        }

        const token = getAccessToken(configuredStore.getState());
        if (token.trim() === "") {
            return;
        }

        let subscription: null | PushSubscription = null;

        try {
            const registration = await navigator.serviceWorker.register(`/root-sw.js?=${uuidv4()}`);
            subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
            });
        } catch (error: any) {
            console.error('There is an error during Service Worker registration:', error);
        }

        if (subscription === null) {
            console.error('Attempt to subscribe failed.');
            return;
        }

        const restApiConfig = new RESTAPIConfig();
        const url = restApiConfig.baseUrl + restApiConfig.apiPrefix + restApiConfig.createNewPushSubscription();

        const userLang = configuredStore.getState().lang.userLang;

        let response = await axios.post<NewBaseResponseInterface<unknown>>(url, JSON.stringify(subscription), {
            headers: {
                'Content-Type': 'application/json',
                [userLangHeaderName]: userLang,
                "Authorization": `Bearer ${token}`,
            }
        });

        if (response.data.result === "success") {
            localStorage.setItem(storageKey, "yes");
        }
    }
}

export function urlBase64ToUint8Array(base64String: string) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}